<div class="wrapper" [ngClass]="[sizeClass, backgroundClass, avatarClass, hasShadow, isRounded]">
  <img class="photo" *ngIf="getImagePath(); else initials" [src]="getImagePath()" alt="" />

  <ng-template class="initials" #initials>
    {{ getInitials() }}
  </ng-template>
</div>
